module.exports = __webpack_public_path__ + "img/claim.56935cc5.webp";